<template>
	<div class="foldSide">
		<div class="fold" @click="toClose">>> 展开</div>
		<div class="main">
			<img :src="logo || require('@/assets/default.png')" class="img" />
			<div class="name">{{ nickname }}</div>
			<div v-if="email">
				<!-- <el-tooltip effect="dark" content="发送邮件" placement="top">
					<div class="icon_body" @click="toSkip">
						<ig-icon name="youxiang3"></ig-icon>
					</div>
				</el-tooltip> -->
				<el-tooltip effect="dark" content="复制邮箱地址" placement="top">
					<div class="icon_body">
						<ig-icon
							name="copy"
							v-clipboard="email"
							v-clipboard:success="clipboardSuccess"
							v-clipboard:error="onError"
						></ig-icon>
					</div>
				</el-tooltip>
			</div>
		</div>
		<div class="bottom">
			<slot></slot>
		</div>
	</div>
</template>
<script>
// import { create as createUrlParams } from '@/common/routerParams.js';
export default {
	props: {
		nickname: {
			type: String,
		},
		email: {
			type: String,
		},
		logo: {
			type: String,
		},
	},
	data() {
		return {};
	},
	computed: {},

	methods: {
		toClose() {
			this.$emit('changeSide', false);
		},
		clipboardSuccess() {
			this.$message({
				message: '复制到剪贴板成功',
				type: 'success',
				duration: 1500,
			});
		},
		onError() {
			this.$message({
				message: '复制到剪切板失败',
			});
		},
		// toSkip() {
		// 	const params = createUrlParams({
		// 		name: 'emailEdit',
		// 		bodyParams: {
		// 			mailbox: [this.email],
		// 			name: 'send',
		// 		},
		// 	});
		// 	this.$router.push(params);
		// },
	},
};
</script>

<style lang="scss" scoped>
.foldSide {
	height: calc(100vh - 165px);
	width: 60px;
	text-align: center;
	/* display: flex;
	flex-direction:column; */
}
.fold {
	line-height: 55px;
	height: 55px;
	border-bottom: 1px #e8e8e8 solid;
	font-weight: 400;
	color: #333333;
	font-size: 12px;
	padding: 0px 3px;
	cursor: pointer;
	position: relative;
}
.main {
	/* flex-grow:8; */
	text-align: center;
}
.img {
	background: #d3d6db;
	width: 40px;
	height: 40px;
	border-radius: 20px;
	object-fit: contain;
	display: inline-block;
	vertical-align: top;
	margin-top: 20px;
}
.name {
	font-weight: 500;
	color: #333333;
	line-height: 22px;
	font-size: 16px;
	padding: 20px 10px;
	border-bottom: 1px #e8e8e8 solid;
	width: 60px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	display: block;
}
.email {
	display: flex;
	justify-content: center;
}
.icon_body {
	cursor: pointer;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	line-height: 26px;
	background-color: rgba(61, 161, 255, 1);
	font-size: 18px;
	color: #fff;
	margin: 20px;

	.icon-youxiang3 {
		font-size: 18px;
	}
}
.bottom {
	width: 60px;
	position: absolute;
	/* border-top: 1px #e8e8e8 solid; */
	bottom: 25px;
}
</style>
